'use client'
import { useState } from 'react'
import { Box, Flex, Image, Link, Text } from '@chakra-ui/react'
import RedeemableBalance from './sections-ui/redeemable-balance'
import EarningRequirement from './sections-ui/earning-requirement'
import Requirement from './sections-ui/requirement'
import EstimatedTotalBalance from './sections-ui/estimated-total-balance'
import RecentActivity from './sections-ui/earnings-table/recent-activity-table'
import { useUser } from '@/src/store/user-store'
import WalletCycle from './sections-ui/wallet-cycle'
import MinimumBalanceRedemption from './sections-ui/min-balance'
import { useWalletBalanceQuery } from '@/src/queries/earnings/wallet-balance'
import CombineMoreInfo from './modals/combine-more-info'
import GuestViewEarnings from './sections-ui/guest-view-earnings'

const Page = () => {
  const { user, _hasHydrated } = useUser()
  const walletBalance = useWalletBalanceQuery()
  const [isCombineMoreInfoOpen, setCombineMoreInfoOpen] = useState(false)

  const handleCombineMoreInfoOpen = () => {
    setCombineMoreInfoOpen(true)
  }

  return (
    <>
      <CombineMoreInfo
        isOpen={isCombineMoreInfoOpen}
        onClose={() => setCombineMoreInfoOpen(false)}
      />
      <Box pb={10} px={4}>
        <Flex
          justifyContent={'space-between'}
          alignItems={'center'}
          my={{ base: 4, sm: 5 }}
        >
          <Text
            className="text-[#656565]"
            fontSize={24}
            fontWeight={['500', '500', '600']}
          >
            Earnings
          </Text>

          <Flex className="items-center justify-center gap-3 rounded-xl border-2 border-[#D3D3D3] bg-[#D0D0D033] px-4 py-1 font-semibold text-[#3E3E3E]">
            <Text className="max-sm:text-[12px]">1 USD$</Text>
            <Image src="/rewards/compare.svg" alt="compare" boxSize={4} />

            <Flex className="items-center gap-1">
              <Image boxSize={7} src="/logo-color-circle.svg" alt="Lykstage" />
              <Text className="max-sm:text-[12px]">50 LYK Coins</Text>
            </Flex>
          </Flex>
        </Flex>

        <Box className="grid grid-cols-2 gap-6 md:grid-cols-3">
          <Flex className="col-span-2 flex-col">
            {!user && _hasHydrated ? (
              <GuestViewEarnings />
            ) : (
              <EstimatedTotalBalance />
            )}

            {!user && _hasHydrated ? (
              <></>
            ) : (
              <>
                <div className="mb-6 block sm:hidden">
                  <div className="my-4 flex items-center sm:hidden">
                    <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                    <span className="mx-2 text-sm font-semibold text-[#24BFA3]">
                      Redeemable
                    </span>
                    <div className="flex-grow border-t-2 border-[#ECECEC]"></div>
                  </div>

                  <RedeemableBalance viewport="mobile" />
                </div>

                {!walletBalance.data?.unVerifiedRedeem.lykCoin &&
                !walletBalance.data?.unVerifiedRedeem.moneyValue ? (
                  <div className="mb-6 block sm:hidden">
                    <MinimumBalanceRedemption />
                  </div>
                ) : (
                  <> </>
                )}
              </>
            )}

            <div className="block sm:hidden">
              <WalletCycle />
            </div>

            {!user && _hasHydrated ? (
              <></>
            ) : (
              <Box>
                <Flex
                  alignItems={'center'}
                  justifyContent={{
                    base: 'space-between',
                    sm: 'start',
                  }}
                  fontSize={{ base: 16, sm: 18 }}
                >
                  <Text
                    className="mb-2 mt-3 text-[#656565] sm:mt-5"
                    fontSize={24}
                    fontWeight={600}
                  >
                    Earning Breakdown
                  </Text>
                  <Flex
                    color={'lyk-green'}
                    display={{ base: 'flex', sm: 'none' }}
                    className="items-center font-semibold"
                  >
                    More info{' '}
                    <Image
                      boxSize={5}
                      src={'/rewards/breakdown/info-green.svg'}
                      alt="Icon"
                      cursor={'pointer'}
                      marginLeft={'4px'}
                      onClick={handleCombineMoreInfoOpen}
                    />
                  </Flex>
                </Flex>

                <RecentActivity />
              </Box>
            )}

            <div className="my-6 block sm:hidden">
              <Requirement />

              <Flex className="mt-4 w-full cursor-pointer justify-center gap-2 text-[12px] font-semibold text-[#797979] no-underline">
                <Link href="/termsofservice">TOS</Link>
                <Link href="/community" className="flex items-center gap-1">
                  <div className="h-1.5 w-1.5 rounded-full bg-[#797979]"></div>
                  Community Guidelines
                </Link>
                <Link href="/faqs" className="flex items-center gap-1">
                  <div className="h-1.5 w-1.5 rounded-full bg-[#797979]"></div>
                  FAQs
                </Link>
              </Flex>
            </div>
          </Flex>

          <Box className="col-span-1" display={{ base: 'none', md: 'block' }}>
            <MinimumBalanceRedemption />

            {!user && _hasHydrated ? (
              <></>
            ) : (
              <>
                <hr className="my-6 font-semibold text-[#DDDDDD]" />

                <div className="hidden sm:block">
                  <RedeemableBalance viewport="desktop" />
                </div>
              </>
            )}
            <EarningRequirement />
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default Page
